import React from 'react';
import Link from 'gatsby-link'
import styles from './Fellows.module.scss';
import Img from 'gatsby-image'

class Fellows extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: 0
    }

    this.updateSelected = this.updateSelected.bind(this)
  }

  componentDidMount() {
    var Flickity = require('flickity');
    const carousel = document.querySelector('#fellowsSlider')
    const options = {
          cellSelector: '.fellowsCard',
          contain: true,
          initialIndex: 0,
          adaptiveHeight: true,
          accessibility: true,
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          lazyLoad: true
    }

    window.setTimeout(() => {
      this.flkty = new Flickity(carousel, options);
      this.flkty.on('cellSelect', this.updateSelected);
    }, 500)
  }

  updateSelected() {
    var index = this.flkty.selectedIndex;
    this.setState({
      selectedIndex: index
    });
  }

  componentWillUnmount() {
    if (this.flkty) {
      this.flkty.off('cellSelect', this.updateSelected);
      this.flkty.destroy();
    }
  }

  render() {
    return (
      <div className={`${styles.Fellows}${this.props.className ? ` ${this.props.className}` : ''}`} style={ this.props.style } id={this.props.id}>
        <div className={styles.Fellows__Wrapper}>
          <h2 className="h2">{this.props.title}</h2>
          <div onClick={() => this.flkty.previous()} className={`${styles.SelectArrow} ${styles.SelectArrow__Prev}`}><img src="/images/icon-circle-arrow.svg" alt="circle arrow" /></div>
          <div className={styles.BlogCards} id="fellowsSlider">
            {this.props.cards.map((card, i) =>
              <Link to={card.link} className={`${styles.BlogCard} fellowsCard`} key={i}>
                <Img sizes={card.articleImage.sizes } alt={card.articleImage.title} />
                <div className={styles.BlogCard__Text}>
                  <p className={styles.BlogCard__Details}><span>{card.storyPosition}</span> / {card.storyLocation}</p>
                  <h3>{card.quoteTitle}</h3>
                  <p className={styles.BlogCard__Author}>&mdash; {card.attribution}</p>
                  <p>{card.quoteText}</p>
                </div>
              </Link>
            )}
          </div>
          <div onClick={() => this.flkty.next()} className={`${styles.SelectArrow} ${styles.SelectArrow__Next}`}><img src="/images/icon-circle-arrow.svg" alt="circle arrow" /></div>
          {
              !this.props.noread && this.props.link &&
              <Link className={`hoverlink ${styles.hoverlink}`} to={this.props.link.link}>{this.props.link.text}</Link>
          }
        </div>
      </div>
    )
  }
}

export default Fellows;



// WEBPACK FOOTER //
// ./src/components/Fellows/index.js